import { createAsyncThunk } from '@reduxjs/toolkit'

import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { TypeTicketController } from 'controller/typeticket'

type Returned = ITypeTicketData[]

type Props = {
  ids: number[]
  eventId?: number
}

export const getBulkData = createAsyncThunk<Returned, Props>('pages/typeticket/bulk', async (props) => {
  const { ids, eventId } = props

  const data = await TypeTicketController.getBulkData({ ids })

  if (eventId) {
    return data.items.map((x) => {
      return { ...x, eventId: eventId }
    })
  }

  return data.items
})
